import BookingOverviewTab from "./sub_tabs/BookingOverviewTab";
import ManageOverviewTab from "./sub_tabs/ManageOverviewTab";

const overViewTabRouter = {

  open_close_auditions: 
  {
    title: 'Manage',
    element: <ManageOverviewTab />
  },

  booking_link: 
  {
    title: 'Booking Page',
    element: <BookingOverviewTab />
  }

  // TO BE ADDED
  // stats: 
  // {
  //   title: 'Stats',
  //   element: <p>Stats</p>
  // }

}

export default overViewTabRouter;